import { TFunction } from 'next-i18next';

export const mapEmailApiError = (msg: unknown, t: TFunction) => {
  if (typeof msg !== 'string') return t('common:error.email.reason.generic');
  if (/recaptcha/i.test(msg)) return t('common:error.email.reason.captcha');
  if (/Email limit reached/i.test(msg)) return t('common:error.email.reason.limitReached');

  return msg;
};
